import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-unit-edit',
    templateUrl: './breadcrumb.unit.edit.component.html'
})

export class BreadcrumbUnitEditComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() facilityId: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
